'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LimitContainer = undefined;

var _isNumber = require('d2-utilizr/lib/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LimitContainer = exports.LimitContainer = undefined;

exports.LimitContainer = LimitContainer = function LimitContainer(refs) {
    var i18n = refs.i18nManager.get();

    Ext.define('Ext.ux.container.LimitContainer', {
        extend: 'Ext.container.Container',
        alias: 'widget.limitcontainer',
        layout: 'hbox',
        sortOrder: null,
        topLimit: null,
        comboboxWidth: null,
        comboBottomMargin: null,
        onCheckboxChange: function onCheckboxChange(value) {
            this.sortOrderCmp.setDisabled(!value);
            this.topLimitCmp.setDisabled(!value);
        },
        getSortOrder: function getSortOrder() {
            return this.activateCmp.getValue() ? this.sortOrderCmp.getValue() : 0;
        },
        getTopLimit: function getTopLimit() {
            return this.activateCmp.getValue() ? this.topLimitCmp.getValue() : 0;
        },
        setValues: function setValues(sortOrder, topLimit) {
            sortOrder = parseInt(sortOrder);
            topLimit = parseInt(topLimit);

            if ((0, _isNumber2.default)(sortOrder)) {
                this.sortOrderCmp.setValue(sortOrder);
            } else {
                this.sortOrderCmp.reset();
            }

            if ((0, _isNumber2.default)(topLimit)) {
                this.topLimitCmp.setValue(topLimit);
            } else {
                this.topLimitCmp.reset();
            }

            this.activateCmp.setValue(!!(sortOrder > 0 && topLimit > 0));
        },
        initComponent: function initComponent() {
            var container = this,
                activateWidth = 135,
                sortWidth = (this.comboboxWidth - activateWidth) / 2;

            this.activateCmp = Ext.create('Ext.form.field.Checkbox', {
                boxLabel: container.boxLabel,
                width: activateWidth,
                style: 'margin-bottom:4px',
                listeners: {
                    change: function change(cmp, newValue) {
                        container.onCheckboxChange(newValue);
                    }
                }
            });

            this.sortOrderCmp = Ext.create('Ext.form.field.ComboBox', {
                cls: 'ns-combo',
                style: 'margin-bottom:' + container.comboBottomMargin + 'px',
                width: sortWidth,
                queryMode: 'local',
                valueField: 'id',
                editable: false,
                value: container.sortOrder,
                store: Ext.create('Ext.data.Store', {
                    fields: ['id', 'text'],
                    data: [{ id: -1, text: i18n.bottom }, { id: 1, text: i18n.top }]
                })
            });

            this.topLimitCmp = Ext.create('Ext.form.field.Number', {
                width: sortWidth - 1,
                style: 'margin-bottom:' + container.comboBottomMargin + 'px; margin-left:1px',
                minValue: 1,
                maxValue: 10000,
                value: container.topLimit,
                allowBlank: false
            });

            this.items = [this.activateCmp, this.sortOrderCmp, this.topLimitCmp];

            this.self.superclass.initComponent.call(this);
        },
        listeners: {
            render: function render() {
                this.onCheckboxChange(false);
            }
        }
    });
};
//# sourceMappingURL=LimitContainer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ux/LimitContainer.js
 ** module id = 176
 ** module chunks = 0 1
 **/